import React from 'react';
import {
  Box,
} from '@mui/material';
import { Outlet } from 'react-router-dom';

const UserLayout = () => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      bgcolor: 'black' // Always dark mode
    }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'black', // Always dark mode
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default UserLayout; 